import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const UserCertifications = () => {
  const [certifications, setCertifications] = useState([]);
  const [certificationName, setCertificationName] = useState("");
  const [issueAuthority, setIssueAuthority] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [certificationPath, setCertificationPath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        const response = await AxiosInstance.get("companies/certifications/");
        if (response.status === 200) {
          setCertifications(response.data);
        } else {
          setErrorMessage("Failed to load certifications.");
        }
      } catch (error) {
        console.error("Error fetching certifications:", error);
        setErrorMessage("Failed to load certifications.");
      }
    };
    fetchCertifications();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (!userId) {
      setErrorMessage("User not logged in. Please login first.");
      setIsLoading(false);
      return;
    }

    if (!certificationName || !issueAuthority) {
      setErrorMessage("Please fill in all required fields.");
      setIsLoading(false);
      return;
    }

    const newCertification = {
      user: userId,
      certification: certificationName,
      issue_authority: issueAuthority,
      issue_date: issueDate || null,
      expiry_date: expiryDate || null,
      certificate_path: certificationPath || null,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/certifications/",
        newCertification
      );

      if (response.status === 201) {
        alert("Certification added successfully!");
        navigate(-1);
      } else {
        setErrorMessage("Failed to save certification.");
      }
    } catch (error) {
      console.error("Error saving certification:", error);
      setErrorMessage("Error saving certification. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Add Certification</h5>
            </div>

            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>

                <div className="mb-3">
                  <label htmlFor="certificationName" className="form-label">
                    Certification Name <span className="text-danger">*</span>
                  </label>
                  <select
                    id="certificationName"
                    className="form-select"
                    value={certificationName}
                    onChange={(e) => setCertificationName(e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Select Certification</option>
                    {certifications.map((cert) => (
                      <option key={cert.certification_id} value={cert.certification_id}>
                        {cert.certification_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label htmlFor="issueAuthority" className="form-label">
                    Issue Authority <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="issueAuthority"
                    className="form-control"
                    value={issueAuthority}
                    onChange={(e) => setIssueAuthority(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="issueDate" className="form-label">
                    Issue Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="issueDate"
                    className="form-control"
                    value={issueDate}
                    onChange={(e) => setIssueDate(e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="expiryDate" className="form-label">
                    Expiry Date
                  </label>
                  <input
                    type="date"
                    id="expiryDate"
                    className="form-control"
                    value={expiryDate}
                    onChange={(e) => setExpiryDate(e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="certificationPath" className="form-label">
                    Certification Path (URL)
                  </label>
                  <input
                    type="url"
                    id="certificationPath"
                    className="form-control"
                    value={certificationPath}
                    onChange={(e) => setCertificationPath(e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save Certification"}
                  </button>
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default UserCertifications;
